import {
  IdPrimitiveValue,
  IdPrimitiveValueCollection,
  OptionsPropertyDefinition,
  toIdPrimitiveValueCollection,
  toNativePrimitiveArray
} from '@shared/models/schema-property-definition';

export namespace Relationship {
  export type SchemaPropertyDefinition = OptionsPropertyDefinition;
  export type SchemaContract = IdPrimitiveValueCollection<string>;
  export interface Model extends IdPrimitiveValue<string> {}

  export function toModel(values: SchemaContract): Model[] {
    return toNativePrimitiveArray(values);
  }

  export function toSchemaContracts(values: Model[]) {
    return toIdPrimitiveValueCollection(values);
  }
}
